export const imageTypes = ['png', 'jpeg', 'jpg', 'webp', 'gif'];
export const videoTypes = ['avi', 'wmv', 'mpeg', 'mp4', 'mov', 'm4v', 'asf', 'flv', 'f4v', 'rmvb', 'rm', '3gp', 'vob', 'webm'];
export const audioTypes = ['mp3', 'm4a'];
export const fileTypes = ['docx', 'doc', 'pdf'];

// export const uploadFileType = 'image/png,image/jpeg,image/webp,image/gif,video/mp4,audio/mp3,'
